import React, { useEffect, useContext } from "react";
import "animate.css";
import RouterApp from "./Router";
import { AuthContext } from "./contexts/AuthContext";
import { WorkspaceContext } from "./contexts/WorkspaceContext";
import { socket, updateSocketWorkspace, setSocketUserId } from "./services/socket";
import { setCacheWorkspaceId } from "./services/messageCache";

function WorkspaceSync() {
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);

  useEffect(() => {
    if (user?.userId) {
      setSocketUserId(user.userId);
    }
  }, [user?.userId]);

  useEffect(() => {
    if (currentWorkspace?._id) {
      updateSocketWorkspace(currentWorkspace._id);
      setCacheWorkspaceId(currentWorkspace._id);
    }
  }, [currentWorkspace]);

  return null;
}

function SocketListeners() {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!socket) return;

    socket.on("new_canal_inbox_with_me", (canal) => {
      socket.emit("je_joins_la_nouvelle_room_inbox", canal.roomId);
      if (user) {
        socket.emit("ma_liste_des_discussions_inbox", user.userId);
        socket.emit("tous_mes_messages_inbox_non_lus", user.userId);
      }
    });

    return () => {
      if (socket) socket.off("new_canal_inbox_with_me");
    };
  }, [socket, user]);

  return null;
}

export default function App() {
  return (
    <>
      <WorkspaceSync />
      <SocketListeners />
      <RouterApp />
    </>
  );
}
